import type { FC } from 'react';
import { useSportUrlParams } from '@mwl/core-lib';
import { SportSearch } from '@/components/SportSearch/SportSearch';
import { useMediaWidthDown } from '@/hooks';
import { FilteredLines } from '../../components/FilteredLines/FilteredLines';
import { PinnedLines } from './components/PinnedLines/PinnedLines';
import { TopLines } from './components/TopLines/TopLines';
import type { SportPageProps } from './SportPage.types';
import styles from './SportPage.module.scss';
export const SportPage: FC<SportPageProps> = () => {
  const isXsScreen = useMediaWidthDown('screen850');
  const {
    hasFilters,
    search
  } = useSportUrlParams();
  return <div className={styles.root} data-sentry-component="SportPage" data-sentry-source-file="SportPage.tsx">
      {search && !isXsScreen && <SportSearch />}
      {(hasFilters && !search && !isXsScreen || isXsScreen && hasFilters) && <FilteredLines />}
      {(!hasFilters && !search && !isXsScreen || isXsScreen && !hasFilters) && <>
          <PinnedLines />
          <TopLines stage="LIVE" />
          <TopLines stage="PREGAME" />
        </>}
    </div>;
};